import React, { memo, Reducer, useEffect, useMemo, useReducer, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { colors, css, fonts, frames, glyphs, useMediaQuery } from "../../../../Styles"
import { AreaLayout,SuccessAnimation, EditEsfWfSectionModal, MainContentPaddingTypes, NewButtonList, NewModal, ESF_STATIONLIST, EsfStationModal, EsfSectionModal, EsfAnimalModal, BluePrintModal, NewSectionModal, PageHeader, ToggleBox, Overlay, LoadingSpinner, NewInput } from "../../../../Components"
import { contents } from "../../../../Components/Layouts/_Layouts/btnContents"
import { getButtonStyles } from "../../../../Components/Layouts/_Layouts/btnStyles"
import { currentEsfViewTypes, EsfContext, EsfDispatcherT, EsfReducer, IEsfContext, useEsfContext } from "../../../../Components/EsfWalkThrough/_EsfWalkThrough/EsfContext"
import { ButtonTypes, NewFieldStyles, NewFieldTypes, SystemTypes } from "../../../../Definitions"
import { RootState, useAppDispatch, useAppSelector } from "../../../../Store"
import { NavigationFunction as RootNavigation, Pages } from "../../../../Navigation/root"
import { Graph_QL, useAnimal } from "../../../../Services"
import { dispatchFetchSectionBySystem, selectSectionsBySystem } from "../../../../Services/Agrisys_GqlDataCaller/SectionsCalls/sectionsSlice"
import { selectLocationsBySystem } from "../../../../Services/Agrisys_GqlDataCaller/SectionsCalls/locationSlice"
import { useSystemInfoById } from "../../../../Services/Agrisys_GqlDataCaller/SystemCalls/systemSlice"
import { isEqual } from "lodash"
import { sortSections } from "../Freeda_lf/freeda_lf_sections"
import { SectionReorder } from "../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/createLfSectionCall"
import { currentContentTypes, currentInnerContentTypes, currentSubContentTypes, IModalContext, ModalContext, ModalDispatcherT, ModalReducer } from "../../../../Components/GlobalModals/_GlobalModals/globalModalContext"
import Esf_Modal from "../../../../Components/EsfWalkThrough/Modals/esf_modal"
import { useSection } from "../../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useSections"

export default function Freeda_esf_sections() {
  const { t } = useTranslation()
  const appDispatch = useAppDispatch();
  const navigator = useNavigate();
  const mobileXs = useMediaQuery(`(max-width: 450px)`);
  const successMode = useSelector((state: RootState) => state.uiState.successMode.successMode);
  const successMessage = useSelector((state: RootState) => state.uiState.successMode.successMessage);
  const [activeLocation, setActiveLocation] = useState<number | undefined>();
  const [currentViewType, setCurrentViewType] = useState< "editSections" | "attention" | "yesterday" | "today" | "basic">("today")
  const [currentModalType, setCurrentModalType] = useState<"newSectionModal" | "blueprintModal" | undefined>(undefined)
  
  const sectionOrderRef = useRef<Record<number, SectionReorder>>({})
  const [sectionOrderRecord, setSectionOrderRecord] = useState<Record<number, SectionReorder>>({})
  const { reorderSectionLocations } = useSection()
  
  // #region | GraphQL
  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const { domain, connection } = useMemo(() => {
    let domain = Graph_QL.ObjToString({ domain: farm });
    let connection = Graph_QL.create({ domain: farm });
    return { domain, connection };
  }, [farm]);

  // const { call: getAnimalsInfo, data: animalsState, maintainEntries: updateAnimals } = useAnimal(connection); // TODO DELETE
  const { systemId: urlSystemId } = useParams();
  const systemId = Number(urlSystemId)    

  // Data gets
  // useEffect(() => {
  //   getAnimalsInfo({ fetchAmount: 51 }, connection); // TODO DELETE
  // // eslint-disable-next-line
  // }, [])

  appDispatch(dispatchFetchSectionBySystem(systemId));

  // System
  const {isLoading: loading, entity: system} = useSystemInfoById(systemId); 

  const sections = useAppSelector((state) => selectSectionsBySystem(state, systemId), isEqual);
  const locations = useAppSelector((state) => selectLocationsBySystem(state, [systemId]), isEqual)
  
  // Sections Info (skal slettes)
  const sectionInfo = useMemo(() => {
    if (!sections) return { currentSectionIndex: -1, currentSectionName: "", currentSectionStations: [] };
    const currentSection = sections.find(section => section.section_locations.some(location => location.location_id === activeLocation))
    const currentSectionIndex = sections.findIndex(section => section.section_locations.some(location => location.location_id === activeLocation))
    const currentSectionName = sections?.[currentSectionIndex]?.name

    return {
      currentSection,
      currentSectionIndex,
      currentSectionName,
    }
  }, [activeLocation, sections])
  
  const [_state, dispatch] = useReducer<Reducer<IEsfContext, EsfDispatcherT>>(EsfReducer, {
    farm: farm,
    domain: domain,
    connection: connection,
    system: system,
    sections,
    currentStationViewType: currentEsfViewTypes.remainingToday,
    error: { Elementid: 0, errorText: "" }
  } as IEsfContext);

  const [_modalState, modalDispatch] = useReducer<Reducer<IModalContext, ModalDispatcherT>>(ModalReducer, {
    farm: farm,
    domain: domain,
    connection: connection,
    currentContent: undefined,
    currentSubContent: undefined,
    currentInnerContent: undefined,
    active: undefined,
    error: { Elementid: 0, errorText: "" }
  } as IModalContext);

  // #region | Button List
  const ButtonRow = memo(({ editTable }: { editTable: boolean }) => {
    const [contentsRes, icons, onClicks] = contents(
      () => { setCurrentModalType("newSectionModal") },
      () => { setCurrentViewType("editSections") },
      () => { setCurrentViewType("today")},
      () => {
        const changes = Array.from(Object.values(sectionOrderRef.current)).filter(({section_order}) => section_order !== 0);
        if (!changes.length) {
          setCurrentViewType("basic");
          setSectionOrderRecord({});
          return;
        }
        reorderSectionLocations(changes);
        setCurrentViewType("today");
        setSectionOrderRecord({});
      },
      t("buttons.add", { defaultValue: "Add" }),
      t("buttons.edit", { defaultValue: "Edit" }),
      t("buttons.cancel", { defaultValue: "Cancel" }),
      t("button.save", {defaultValue: "Save"}),
      editTable
    )
      
    return (
      <NewButtonList 
        contents={contentsRes} 
        onClick={(i) => { onClicks[i]?.() }}
        buttonType={ButtonTypes.tableButton}
        startEnhancers={icons}
        disabled={editTable ? [false, false, true, true] : [false, false] }
        overrides={(index) => {
          const { backgroundColor, opacity } = getButtonStyles(index, editTable);
          return {
            baseButton: { backgroundColor: backgroundColor },
            disabledStyles: { opacity: opacity, backgroundColor: backgroundColor }
          }
        }}
      />
    )
  })
  // #endregion

  // #region | Visited Pen
  const thisActivePen = useSelector((state: RootState) => state.uiState.modalRedirect.activePen);
  const hasLastVisitedPen = thisActivePen?.type === "esf" && thisActivePen.system === system?.system_id;
  const lastVisitedSection = thisActivePen?.type === "esf" ? thisActivePen.group : _modalState.activeLocation;
  //#endregion
  
  return (
    <frames.Page_inner>
      <PageHeader
        topHeader={system?.name}
        subHeader={t(`menuHeaders.${Pages.freeda_esf_sections}`, {defaultValue: "sections"})}
      />
      <frames._page_inner_content style={{ zIndex: currentViewType === "editSections" ? "9999" : "0" }}>
        <AreaLayout
          zIndex={currentViewType === "editSections" ? 999 : 0}
          editableTable={currentViewType === "editSections"}
          headerArea={
            <p style={{ ...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary, marginBottom: "5px" }}>
              {locations?.length} {locations?.length === 1 ? t("esfWalkThroughPages.sections.pen", { defaultValue: "pen" }) : t("esfWalkThroughPages.sections.pens", { defaultValue: "pens" })}
            </p>
          }
          buttonArea={<ButtonRow editTable={currentViewType === "editSections" ? true : false} />}
          topArea={
            <frames.ToggleBox style={{ columnGap: mobileXs ? "10px" : "30px" }}>
              <ToggleBox
                disabled={currentViewType === "editSections" ? true : false}
                text={t("feed.general.remainingToday", { defaultValue: "remaining today" })}
                icon={glyphs.TimeToday({ size: "17px" })}
                onChange={() => { setCurrentViewType(currentViewType === "today" ? "basic" : "today"); dispatch({ currentStationViewType: currentViewType === "today" ? currentEsfViewTypes.basic : currentEsfViewTypes.remainingToday })}}
                isChecked={currentViewType === "today" ? true : false}
              />
              <ToggleBox
                disabled={currentViewType === "editSections" ? true : false}
                text={t("feed.general.remainingYesterday", { defaultValue: "remaining yesterday" })}
                icon={glyphs.TimeYesterday({ size: "17px" })}
                onChange={() => { setCurrentViewType(currentViewType === "yesterday" ? "basic" : "yesterday"); dispatch({ currentStationViewType: currentViewType === "yesterday" ? currentEsfViewTypes.basic : currentEsfViewTypes.remainingYesterday })}}
                isChecked={currentViewType === "yesterday" ? true : false}
              />
              <ToggleBox
                disabled={currentViewType === "editSections" ? true : false}
                text={t("systemControls.general.attentions", { defaultValue: "attentions" })}
                icon={<div style={{ marginTop: "1px" }}><glyphs.Attention size="17px" /></div>}
                onChange={() => { setCurrentViewType(currentViewType === "attention" ? "basic" : "attention"); dispatch({ currentStationViewType: currentViewType === "attention" ? currentEsfViewTypes.basic : currentEsfViewTypes.attention })}}
                isChecked={currentViewType === "attention" ? true : false}
              />
            </frames.ToggleBox>
          }
          contentArea={<>
            {loading && <div style={{width: "100%", display: "flex", justifyContent: "center"}}><LoadingSpinner /></div>}
            {(!loading && (sections.length === 0 || sections === undefined)) ? <p style={{...css.emptyPen, textAlign: "center"}}>{t("esfWalkThroughPages.sections.noPens", {defaultValue: "No pens found"})}</p> : <></>}
            {!loading && (sections.length !== 0 || sections !== undefined) &&
              <EsfContext.Provider value={{ state: _state, dispatch }}>
                <frames.PenListsWrapper style={{ justifyContent: mobileXs ? "center" : "start" }}>
                  {system && sections ?.sort((a, b) => sortSections(a, b, sectionOrderRecord)).map((section) => {
                    const sectionLocations = locations?.filter((loc) => loc.sectionId === section.section_id);

                    return (
                      <div key={section.section_id}>
                        {sectionLocations?.map((location) => (
                          <div key={location.location_id} style={{ height: "fit-content", width: "fit-content" }} onClick={() => {
                            currentViewType === "editSections"
                            ? setActiveLocation(location.location_id)
                            : modalDispatch({
                              activeLocation: location.location_id,
                              currentContent: currentContentTypes.location,
                              currentInnerContent: currentInnerContentTypes.stations
                            });
                          }}>
                            <ESF_STATIONLIST
                              key={location.location_id}
                              location={location}
                            />
                          </div>
                        ))}
                      </div>
                    );
                  })}
                </frames.PenListsWrapper>
              </EsfContext.Provider>}
          </>}

          additionalArea={ <div style={{display: "flex", flexDirection: "column", gap: "5px"}}>
          <div style={{ display: "grid", gridTemplateColumns: "200px 60px", gridTemplateRows: "auto", gap: "20px" }}>
            <p style={{ ...fonts.fontSize4, ...fonts.paragraph, ...fonts.fontWeight2, color: colors.whitePrimary, borderBottom: "2px solid "+colors.greySecondary+80 }}>{t("locationFeederPages.sections.section", { defaultValue: "Section" })}</p>
            <p style={{ ...fonts.fontSize4, ...fonts.paragraph, ...fonts.fontWeight2, color: colors.whitePrimary, borderBottom: "2px solid "+colors.greySecondary+80 }}>{t("locationFeederPages.sections.priority", { defaultValue: "Priority" })}</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            {sections.sort(sortSections).map((section) => (
              <div style={{display: "grid", gridTemplateColumns: "200px 60px", gridTemplateRows: "auto", gap: "20px"}}>
                <p style={{...fonts.fontSize4, ...fonts.paragraph, color: colors.greyLightTertiary, display: "flex", alignItems: "center"}}>{section.name}</p>
                <NewInput
                  onChange={(value) => {
                    if (Number(value) === section.section_order || (value === "" && section.section_order === -1) ) {
                      sectionOrderRef.current[section.section_id] = {section_id: section.section_id, section_order: 0}
                      return;
                    }
                    sectionOrderRef.current[section.section_id] = {section_id: section.section_id, section_order: value === "" ? -1 : Number(value)}
                  }}
                  onBlur={() => setSectionOrderRecord({...sectionOrderRef.current})}
                  fieldOverrides={{
                    fieldType: NewFieldTypes.tertiaryField,
                    fieldStyle: NewFieldStyles.greySecondary,
                    fieldWidth: "60px"
                  }}
                  valueOverrides={{
                    valueType: "number",
                    defaultValue: section.section_order > 0 ? section.section_order : undefined,
                    minValueNumber: 1,
                    maxValueNumber: 99,
                    allowDelete: true,
                  }}
                />
              </div>
            ))}
          </div>
        </div>}
          bluePrint={{
            disabled: currentViewType === "editSections" ? true : false,
            onClick: () => setCurrentModalType("blueprintModal"),
            startEnhancer: glyphs.BluePrint({})
          }}
          lastVisitedLocation={{ 
            onClick: () =>  {
              modalDispatch({
                activeLocation: lastVisitedSection ?? -1,
                currentContent: currentContentTypes.location,
                currentInnerContent: currentInnerContentTypes.stations
              })
            },
            disabled: !hasLastVisitedPen
          }}
        />
      </frames._page_inner_content>
      
      {/* Section/Station Modal */}
      {currentViewType !== "editSections" && system && (_modalState.currentContent !== undefined) ? 
        <ModalContext.Provider value={{ state: _modalState, dispatch: modalDispatch }}>
          <Esf_Modal system={system}/>
        </ModalContext.Provider>
      : <></>}

      {/* Blue Print Modal */}
      {currentModalType === "blueprintModal" && system && (
        <BluePrintModal system={system} onClose={() => setCurrentModalType(undefined)}/>
      )}
    
      {/* New Section Modal */}
      {currentModalType === "newSectionModal" && (
        <NewSectionModal 
          closeModal={() => {setCurrentModalType(undefined); setCurrentViewType("today")}}
          systemId={systemId}
          systemType={SystemTypes.freedaEsf_WalkThrough}
        />
      )}

      {currentViewType === "editSections" && (sectionInfo.currentSection === undefined || activeLocation === undefined
        ? <Overlay />
        : <EsfContext.Provider value={{ state: _state, dispatch }}>
            <EditEsfWfSectionModal
              closeModal={() => { setActiveLocation(undefined); setCurrentViewType("today"); dispatch({ currentStationViewType: currentEsfViewTypes.remainingToday, selectedStations: [] }); }}
              location={locations.find(l => l.location_id === activeLocation) ?? locations[0]}
              section={sectionInfo.currentSection}
            />
          </EsfContext.Provider>
        )}
      { successMode && <SuccessAnimation/>}
    </frames.Page_inner>
  )
}